import React, { FunctionComponent } from 'react';
import { Modal } from 'components';

export const TermsAndConditionsModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
  termsAndConditionsElement: JSX.Element;
  heading: string;
}> = ({ isOpen, onClose, termsAndConditionsElement, heading }) => (
  <Modal
    header={heading || 'Terms and Conditions'}
    isOpen={isOpen}
    onClose={onClose}
  >
    {termsAndConditionsElement}
  </Modal>
);

export default TermsAndConditionsModal;
